export function formatRupiah(n) {
  if (n === null || n === undefined || n === "" || Number.isNaN(Number(n))) return "Data belum tersedia";
  return "Rp" + Number(Math.round(n)).toLocaleString("id-ID");
}

export function formatNumber(n, digits = 0) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "-";
  return Number(n).toLocaleString("id-ID", { maximumFractionDigits: digits });
}

export function orDash(v, suffix = "") {
  if (v === null || v === undefined || v === "") return "Data belum tersedia";
  return `${v}${suffix}`;
}

export const CATEGORY_LABEL = {
  motor_listrik: "Motor Listrik",
  sepeda_listrik: "Sepeda Listrik",
  motor_bensin: "Motor Bensin",
};
